<template>
    <div v-if="!prepaid" class="layer order">
        <paymentModal ref="payment" @success="paymentSuccess" :orderInfo="wechatOrderInfo"/>
        <AddressForm ref="addressForm" @submitSuccess="getList" />
        <!-- <Form ref="form" @submitSuccess="addAddressSuccess" @editSuccess="editAddressSuccess" /> -->
        <div class="contentWrap fl" v-if="!orderCreated" style="width:100%">
            <div class="contentTitle">选择收货地址</div>
            <div class="content">
                <div class="address">
                   <div v-for="(item,index) in addressData.list" :key="index" class="addressDiv" :class="`${item.is_default === 1 ? 'default' : ''} ${defaultChecked === item.address_id ? 'checked' : ''}`" @click="checkAddress(item.address_id)">
                       <div style="line-height: 15px;">
                           <span class="is_default" v-if="item.is_default === 1">默认</span>
                           <span style="margin-right:8px;">{{ item.consignee }}</span>
                           <span>{{ item.mobile }}</span>
                        </div>
                        <div style="margin-top: 15px;">
                            {{ item.area }}
                        </div>
                   </div>
                </div>
            </div>
        </div>
        <div class="colorBlue csp address" v-if="!orderCreated">
            <div class="addressMng" @click="gotoAddress">
                管理收货地址
            </div>
            <div class="addAddress" @click="addAddress">
                新增地址
            </div>
        </div>
        <div>
            <div class="orderTitle">确认订单信息</div>
            <div class="orderContent">
                <el-table :data="cartList" v-if="cartList && cartList.length">
                    <el-table-column label="商品名称" width="400px" align="center">
                        <template slot-scope="props">
                            <img class="goodsImg" :src="spliceImg(props.row.original_img) | thumbnailUrl" />
                            {{ props.row.common_name }}<span v-if="props.row.goods_name!==''">({{ props.row.goods_name }})</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格" prop="goods_spec" align="center"></el-table-column>
                    <el-table-column label="单价" align="center">
                        <template slot-scope="props">
                            ￥{{ props.row.wholesale_price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" prop="goods_num" align="center"></el-table-column>
                    <el-table-column label="原价" align="center">
                        <template slot-scope="props">
                            ￥{{ props.row.original_price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠" align="center">
                        <template slot-scope="props">
                            ￥{{ props.row.reduce }}
                        </template>
                    </el-table-column>
                    <el-table-column label="应付" align="center">
                        <template slot-scope="props">
                            ￥{{ props.row.pay_price }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="orderInfo">
                    <div class="remarks">
                        <span>备注:</span>
                        <textarea v-if="!orderCreated" v-model="user_note" />
                        <label v-else>{{user_note}}</label>
                    </div>
                    <div v-if="orderCreated" class="priceInfo">
                        <div class="priceItem">快递费<label class="price ">{{createdOrderInfo.shipping_price}}元</label></div>
                        <div class="priceItem">商品合计<label class="price">{{createdOrderInfo.goods_total_price || createdOrderInfo.goods_price}}元</label></div>
                        <div class="priceItem">积分抵扣<label class="price">{{createdOrderInfo.integral}}</label></div>
                        <div class="priceItem">总计<label class="price">{{createdOrderInfo.order_amount}}元</label></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!orderCreated">
            <div class="transactionTitle">交易方式</div>
            <div class="transactionContent">
                <el-row>
                    <!-- <el-button @click="changePayWay(1)">支付宝付款</el-button> -->
                    <!-- <el-button @click="changePayWay(1)">微信付款</el-button>
                    <el-button @click="changePayWay(0)">预付款</el-button> -->
                    <el-radio-group v-model="payWay">
                        <el-radio-button :label="0">微信付款</el-radio-button>
                        <el-radio-button :label="1">预付款</el-radio-button>
                    </el-radio-group>
                    <el-checkbox v-model="checked" style="float:right">启用积分</el-checkbox>
                    <div v-if="checked" style="margin-top:2px"><span style="float:right">抵用积分: {{ total.all_integral }}个积分</span></div>
                </el-row>
            </div>
        </div>
        <div v-if="!orderCreated">
            <div class="pay clearfix">
                <div class="payButton" @click="orderSet">确认订单</div>
                <div v-if="checked" class="payNum">实付金额: <span class="colorRed">￥{{ total.dikou_price }}</span></div>
                <div class="payNum">商品金额: <span class="colorRed">￥{{ (total.all_price).toFixed(2) }}</span></div>
            </div>
        </div>
        <div class="createdOrder" v-if="orderCreated">
            <div class="top">
                <div class="orderItem">实付金额<label class="orderValue orderAmount">{{createdOrderInfo.order_amount}}元</label></div>
                <div class="orderItem">寄送到<label class="orderValue">{{selectedAddress.area}}</label></div>
                <div class="orderItem">寄送人<label class="orderValue">{{selectedAddress.consignee}} | {{selectedAddress.mobile}}</label></div>
                <div class="orderItem">支付方式<label class="orderValue">{{payWay === 0 ? '线上支付(微信)' : '预支付'}}</label></div>
                <div class="orderItem">订单过期时间<label class="orderValue orderAmount" :style="{color: countdownTimeStr === '已过期' ? 'red' : 'limegreen'}">{{countdownTimeStr}}</label></div>
            </div>
            <div class="bottom" @click="payment">支付</div>
        </div>
    </div>
    <div v-else class="layer order prepaid">
        <div class="successIcon"></div>
        <label >{{successMsg}}</label>
        <div class="btns">
            <el-button type="small" @click="tolist">订单列表</el-button>
            <el-button type="small" @click="toHome">返回首页</el-button>
        </div>
    </div>
</template>

<script>
import { UserCenterService } from '../../service/userCenter.service.js'
import { OrderService } from '../../service/order.service.js'
import paymentModal from './selectOrderWay.vue';
import AddressForm from '../userCenter/address/formAddress.vue';
import moment from 'moment';
//import Qrcode from '../../components/QRCode/QRCode'

    export default {
        name: 'order',
        components: { paymentModal, AddressForm },
        data() {
            return {
                addressData: '',
                defaultChecked: '',
                payWay: 0,
                user_note: '',
                orderCreated: false,
                createdOrderInfo: {},
                cartList: [],
                successMsg: '预支付订单生成成功',
                prepaid: false,
                countdownTimeStr: '',
                timer: null,
                checked:false,
                total:{}
            }
        },
        computed: {
            integral() {
                let num = 0
                this.cartList.forEach(val=>{
                    num = num + val.pay_price * val.goods_num
                })
                return num
            },
            cart_ids() {
                let arr = []
                this.cartList.forEach(val=>{
                    arr.push(val.id)
                })
                return arr.toString()
            },
            selectedAddress() {
                if (this.addressData && this.addressData.list) {
                    return this.addressData.list.find(item => item.address_id === this.defaultChecked);
                }
                return {};
            },
            wechatOrderInfo() {
                return {
                    ...this.selectedAddress,
                    ...this.createdOrderInfo,
                }
            },
        },
        methods: {
            async getList() {
                const data = await UserCenterService.getList()
                this.addressData = data
                this.addressData.list.forEach(val=>{
                    if(val.is_default == 1) {
                        this.defaultChecked = val.address_id
                    }
                })
            },
            checkAddress(address_id) {
                this.defaultChecked = address_id
            },
            gotoAddress() {
                this.$router.push('/userCenter/address')
            },
            toHome() {
                this.$router.push('/');
            },
            changePayWay(val) {
                this.payWay = val
            },
            payment() {
                this.$refs.payment.open();
            },
            async orderSet() {
                let obj = {};
                obj.user_note = this.user_note;
                obj.address_id = this.defaultChecked;
                obj.pay_type = this.payWay;
                obj.cart_ids = this.cart_ids;
                if(this.checked){
                    obj.integral = 1
                }else{
                    obj.integral = 0
                }
                this.createdOrderInfo = await OrderService.orderSet(obj);
                if (this.payWay === 1) {
                    this.prepaid = true;
                }
                this.countdownTime(moment.unix(this.createdOrderInfo.add_time));
                this.$store.commit('addCartList', [])
                this.orderCreated = true;
            },
            countdownTime(times = 0) {
                window.moment = moment;
                this.timer = setInterval(() => {
                    const diffminute = moment().diff(moment(times), 'seconds');
                    if (diffminute > (15 * 60)) {
                        this.countdownTimeStr = '已过期';
                    } else {
                        this.countdownTimeStr = moment(0).seconds((15 * 60) - diffminute.valueOf()).format('mm:ss');
                    }
                }, 1000);
            },
            spliceImg(imgStr = '') {
                const url = 'https://api.goodyiyao.cn/';
                return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
            },
            makeQrCode() {
                //OrderService.qrcode()
            },
            tolist() {
                this.$router.replace('/userCenter/order');
            },
            paymentSuccess() {
                this.successMsg = '订单支付成功！'
                this.prepaid = true;
            },
            addAddress() {
                this.$refs.addressForm.open('add')
            },
        },
        async created() {
            // 判断是否是从购物车进入
            if (this.$route.query.order_sn) {
                this.createdOrderInfo = await OrderService.getList({ order_sn: this.$route.query.order_sn });
                this.cartList = this.createdOrderInfo.order_goods;
                this.countdownTime(this.createdOrderInfo.add_time)
                this.orderCreated = true;
            } else {
                let id = []
                this.$store.getters.cartList.forEach(item=>{
                    id.push(item.id)
                })
                let a =this
                OrderService.shoppingCartAccount({cart_ids:JSON.stringify(id).substr(1,JSON.stringify(id).length-2)}).then(res=>{
                    a.cartList = res.data
                    a.total = res
                    delete a.total.data 
                })
            }
            // if (!this.cart_ids) {
            //     this.$router.replace('shoppingCart');
            // }
            // 地址信息
            this.getList();
        },
        destroyed() {
            clearInterval(this.timer);
        }
    }
</script>

<style lang="scss" scoped>
        .contentTitle{
            height: 40px;
            line-height: 60px;
            font-weight: 700;
            font-size: 14px;
        }
        .content{
            padding: 0px 0px 10px 0px;
            display: block;
            .el-input{
                width: 300px
            }
            .addressButton{
                display: inline;
                background: rgb(29, 144, 208);
                border: 1px solid #1177b6;
                color: #fff;
                padding: 5px 10px;
            }
            .addAddress{
                position: fixed;
                background: #fff;
                border: 1px solid #e3e2e1;
                box-shadow: 0 0 1px #6f6f6f;
                left: 50%;
                transform: translateX(-50%);
                z-index: 5;
                top: 100px;
                .addAddressTitle{
                    height: 40px;
                    line-height: 40px;
                    font-size: 18px;
                    color: #999;
                    padding-right: 15px;
                    background: #eee;
                    .el-icon-circle-close{
                        cursor: pointer;
                    }
                }
            }
            .address{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                margin-top: 15px;
                .addressDiv{
                    width: 260px;
                    height: 70px;
                    background: url('../../assets/images/views/address-peraddbg.png');
                    background-size: 100% 100%;
                    margin-bottom: 8px;
                    padding: 15px 10px;
                    margin-right: 10px;
                }
                .addressDiv.checked{
                    background-image: url('../../assets/images/views/address-peraddressbg.png')
                }
            }
            
        }
    .iconiconfontxiaogantanhao{
        font-size: 24px;
        vertical-align: sub;
        margin-right: 8px;
    }
    .is_default{
        background: #5eb95e;
        padding: 0.25em 0.5em;
        border-radius: 2px;
        color: #fff;
        margin-right: 15px;
    }
    .op{
        display: flex;
        margin-top: 40px;
        justify-content: flex-end;
        .opbutton{
            padding: 0 8px;
            cursor: pointer;
            i{
              vertical-align: -1px;
            }
        }
        .opbutton:hover{
            color: #d2364c;
        }
    }
    .orderTitle{
        font-size: 14px;
        font-weight: 700;
        margin-top: 20px;
    }
    .orderContent{
        height: auto;
        .goodsImg{
            width: 80px;
            height: 80px;
            object-fit: contain;
        }
    }
    .transactionTitle{
        font-size: 14px;
        margin-top: 20px;
        font-weight: 700;
    }
    .transactionContent{
       margin-top: 20px;
    }
    .pay{
        height: 38px;
        margin-top: 30px;
        line-height: 38px;
        font-size: 13px;
        background: #e5e5e5;
        div{
            float: right;
        }
        .payNum{
            margin-right: 20px;
        }
        .payButton{
            width: 80px;
            cursor: pointer;
            text-align: center;
            background: #e71f19;
            color: #fff;
        }
    }
    .remarks{
        flex: 1;
        padding: 20px 20px;
        border-right: 1px solid #ddd;
        display: flex;
        align-items: center;
        span{
            font-size: 14px;
            font-weight: 700;
        }
        textarea{
            width: calc(100% - 80px);
            margin-left: 15px;
            resize: none;
            border-color: #ccc;
            min-height: 50px;
            padding: 8px 15px;
        }
    }
    .order .el-table th.is-leaf{
        border: none;
        background: #efefef;
    }
    .order .transactionContent .el-button{
        width: 140px;
    }
    .orderInfo {
        background: rgb(242, 248, 255);
        display: flex;
        .priceInfo {
            flex: 1;
            .priceItem {
                display: flex;
                justify-content: flex-end;
                font-size: 3;
                align-items: center;
                font-size: 13px;
                padding-right: 60px;
                height: 45px;
                border-bottom: 1px solid #ddd;
                .price {
                    color: red;
                    width: 180px;
                    text-align: right;
                }
            }
        }
    }
    .orderAmount {
        font-size: 16px;
    }
    .createdOrder {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        .top {
            border: 1px solid red;
            padding: 20px 20px 10px 20px;
            .orderItem {
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: bold;
                display: flex;
                align-items: center;
                .orderValue {
                    font-weight: default;
                    margin-left: 20px;
                    width: 300px;
                }
            }
        }
        .bottom {
            background: red;
            color: #fff;
            height: 50px;
            cursor: pointer;
            width: 240px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            margin-top: 20px;
        }
    }

.successIcon {
	border-radius: 50%;
	height: 100px;
	width: 100px;
	background: rgb(53, 187, 0);
	position: relative;
	margin-bottom: 20px;
  &::before {
    content: " ";
    height: 50px;
    width: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -36px;
    margin-left: -15px;
    border-bottom: 6px solid #fff;
    border-right: 6px solid #fff;
    transform: rotate(45deg);
  }
}
.prepaid {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    margin-top: 60px;
    font-size: 16px;
    .btns {
        margin-top: 20px;
        button {
            border-radius: 6px !important;
            border-color: #2E98D5;
            color: #2E98D5;
        }
    }
}
.address {
    display: flex;
    width: 100%;
}
.addressMng {
    
}

.addAddress {
    margin-left: 13px;
}
</style>
